const state = {
    surname: null,
    lastname: null,
    sex: null,
    age: null,
    height: null,
    weight: null,
    body: null,
    goal: null,
    todayTrainingName: null,
    currentTrainingName: null
}

// getters
const getters = {
    isProfileComplete: state => state.surname !== null && state.lastname !== null && state.sex !== null 
        && state.age !== null && state.height !== null && state.weight !== null 
        && state.body !== null && state.goal !== null,
    getProfileCompletionStep: state => {
        if (state.surname === null || state.lastname === null) {
            return 0
        } else if (state.sex === null) {
            return 1
        } else if (state.age === null) {
            return 2
        } else if (state.height === null) {
            return 3
        } else if (state.weight === null) {
            return 4
        } else if (state.body === null) {
            return 5
        } else if (state.goal === null) {
            return 6
        } else {
            return 7
        }
    },
    getProfile: state => {
        return {
            surname: state.surname,
            lastname: state.lastname,
            sex: state.sex,
            age: state.age,
            height: state.height,
            weight: state.weight,
            body: state.body,
            goal: state.goal
        }
    },
    getTodayTrainingName: state => state.todayTrainingName,
    getCurrentTrainingName: state => state.currentTrainingName
}

// actions
const actions = {
    updateProfile ({ commit, state }, profile) {
        commit('updateName', { surname: profile.surname, lastname: profile.lastname })
        commit('updateAge', profile.age)
        commit('updateSex', profile.sex)
        commit('updateHeight', profile.height)
        commit('updateWeight', profile.weight)
        commit('updateBody', profile.body)
        commit('updateGoal', profile.goal)
    }
}

// mutations
const mutations = {
    updateName (state, { surname, lastname }) {
        if (typeof surname === 'string' && surname.length > 0 && typeof lastname === 'string' && lastname.length > 0) {
            state.surname = surname
            state.lastname = lastname
        } else if (surname === null && lastname === null) {
            state.surname = null
            state.lastname = null
        }
    },
    updateSex (state, sex) {
        if (typeof sex === 'string' && sex.length > 0) {
            state.sex = sex
        } else if (sex === null) {
            state.sex = null
        }
    },
    updateAge (state, age) {
        if (typeof age === 'number' && age > 0) {
            state.age = age
        } else if (age === null) {
            state.age = null
        }
    },
    updateHeight (state, height) {
        if (typeof height === 'number' && height > 0) {
            state.height = height
        } else if (height === null) {
            state.height = null
        }
    },
    updateWeight (state, weight) {
        if (typeof weight === 'number' && weight > 0) {
            state.weight = weight
        } else if (weight === null) {
            state.weight = null
        }
    },
    updateBody (state, body) {
        if (typeof body === 'string' && body.length > 0) {
            state.body = body
        } else if (body === null) {
            state.body = null
        }
    },
    updateGoal (state, goal) {
        if (typeof goal === 'string' && goal.length > 0) {
            state.goal = goal
        } else if (goal === null) {
            state.goal = null
        }
    },
    updateTodayTrainingName (state, name) {
        state.todayTrainingName = name
        updateCurrentTrainingName(state, name)
    },
    updateCurrentTrainingName (state, name) {
        state.currentTrainingName = name
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/fitnes/modules/profile.js